import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';
import attendees from '../../attendee/attendees';

class RemoveCheckinModal extends React.Component {
    state = {
        submitting: false
    };

    removeCheckinsAttendees = async () => {
        const { eventId, orgId, markedAttendee, session, checkedAttendees } = this.props;
        this.setState({ submitting: true })
        await API()
            .patch(`Organizations/${orgId}/events/${eventId}/sessions/${session._id}/exempt`, {
                attendees: checkedAttendees,
                request: 'remove-checkin'
            })
            .then((res) => {
                this.props.removeAttendeesFromCheckin(checkedAttendees, session._id);
                this.props.toggle();
            })
            .catch((e) => {
                console.log(e);
                this.setState({
                    invalid: true,
                    submitting: false
                });
            });
    };

    render() {
        const { isOpen, attendees, toggle, checkedAttendees } = this.props;
        const { submitting } = this.state;

        return (
            <FieldModal
                size="small"
                isOpen={isOpen}
                modalTitle={"Remove Attendees Check In"}
                bodyHeaderText={<span>	You are about to remove <b>{checkedAttendees.length} attendees</b> check ins from this session, would you
                    like to continue?</span>}
                bodyContent={() => {
                    return ('')
                }}
                toggle={toggle}
                actionButtonLabel={!submitting ? 'Remove' : 'Removing...'}
                actionButton={() => this.removeCheckinsAttendees()}
                isDelete={true}
                actionButtonDisabled={submitting}

            ></FieldModal>

        );
    }
}

export default RemoveCheckinModal;
